import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { SkechersOrdersChildEntity } from "../entity/skechers-orders-child.entity";

@Injectable()
export class SkechersOrdersChildRepository extends Repository<SkechersOrdersChildEntity> {

    constructor(@InjectRepository(SkechersOrdersChildEntity) private skechersOrderschildRepository: Repository<SkechersOrdersChildEntity>
    ) {
        super(skechersOrderschildRepository.target, skechersOrderschildRepository.manager, skechersOrderschildRepository.queryRunner);
    }





}